import Axios from 'axios'
import { URLS } from './constants'

const BASE_URL = `${URLS.URL_PRD}/manifest`

const manifestAPI = {

  getResend: async (currentPage = 1, perPage = 10, filters = {}) => {
   const { enterprises, stores, endDate, textSearch } = filters;
   const { data } = await Axios.get(BASE_URL, {
      params: {
        currentPage,
        perPage,
        textSearch,
        ...(endDate && {endDate}),
        ...(enterprises.length>0 && {enterprises: enterprises.map(e => e?.id).join(',')}),
        ...(stores.length>0 && {stores: stores.map(s => s?.id).join(',')}),
      }
    })
    return data
  },

  exportExcelResend: async (manifestIds, stage) => {

    const { data } = await Axios({
      method: 'POST',
      url: `${URLS.URL_PRD}/excel/manifest`,
      data: { manifestIds, stage },
      responseType: 'blob',
    })

    return data
  },

  sendEmailResend: async (manifestIds, email, stage) => {
    const response= await Axios({
      method: 'POST',
      url: `${URLS.URL_PRD}/excel/manifest/email`,
      data: { manifestIds, email, stage },
    })
    return response
  },

  getResendDetail: async (id, currentPage = 1, perPage = 10, filters={}) => {
   const { compromiseDate, textSearch } = filters;
   const { data } = await Axios.get(`${BASE_URL}/id/${id}/purchase-orders`, {
      params: {
        currentPage,
        perPage,
        ...(textSearch&& {textSearch}),
        ...(compromiseDate&& {compromiseDate}),
      }
    })
    return data
  },

  getHistory: async (currentPage = 1, perPage = 10, filters = {}) => {
   const { enterprises, stores, startDate, endDate } = filters;
   const { data } = await Axios.get(`${BASE_URL}/history`, {
      params: {
        currentPage,
        perPage,
        ...((startDate && endDate) && {startDate}),
        ...((startDate && endDate) && {endDate}),
        ...(enterprises.length>0 && {enterprises: enterprises.map(e => e?.id).join(',')}),
        ...(stores.length>0 && {stores: stores.map(s => s?.id).join(',')}),
      }
    })
    return data
  },

  exportExcelHistory: async (dates, filters = {}) => {
   const { enterprises:enterpriseIds, stores:storeIds } = filters;
   const { data } = await Axios({
      method: 'POST',
      url: `${URLS.URL_PRD}/excel/manifest-history`,
      data: {
        dates,
        ...(enterpriseIds.length>0 && {enterpriseIds: enterpriseIds.map(e => e?.id)}),
        ...(storeIds.length>0 && {storeIds: storeIds.map(s => s?.id)}),
      },
      responseType: 'blob',
    })

    return data
  },

  sendEmailHistory: async (dates, email, filters) => {
   const { enterprises:enterpriseIds, stores:storeIds } = filters;
   const { data } = await Axios({
      method: 'POST',
      url: `${URLS.URL_PRD}/excel/manifest-history/email`,
      data: {
        dates,
         email,
         ...(enterpriseIds.length>0 && {enterpriseIds: enterpriseIds.map(e => e?.id)}),
         ...(storeIds.length>0 && {storeIds: storeIds.map(s => s?.id)}),
        },
    })
    return data
  },

  getHistoryDetail: async (date, currentPage = 1, perPage = 10, filters = {}) => {
   const { enterprises, stores, textSearch } = filters;
   const { data } = await Axios.get(`${BASE_URL}/date/${date}/purchase-orders`, {
      params: {
        currentPage,
        perPage,
        textSearch,
        ...(enterprises.length>0 && {enterprises: enterprises.map(e => e?.id).join(',')}),
        ...(stores.length>0 && {stores: stores.map(s => s?.id).join(',')}),
      }
    })
    return data
  },

}

export default manifestAPI
